module.exports = __webpack_public_path__ + "static/Pt16-8e1f6a805eeb4b832476b76eb41a8f29.jpg";